import React, { Component } from 'react'
import { connect } from 'react-redux';
import { putPasswordEmail } from '../_actions/user';
import { TextField, Button } from "@material-ui/core";
import ReactGA from 'react-ga';
import {GAevent} from './TrackingEvent'
import ReactPixel from 'react-facebook-pixel';
import CryptoJS from 'crypto-js';
var key = CryptoJS.enc.Utf8.parse("68D83A2CCC84F2A8B7ADB64B38B86576")
var iv = CryptoJS.enc.Utf8.parse("116C893F5CF1AA0AFAABBF28C32CFBE2")  


class ChangePwd extends Component {
    constructor(props) {
        super(props);
        this.state = {
          user_id:0,
          fields: {
            new_password:"",
            confirm_password:"",
          },
          forgotPassword: false,
          formIsValid:false,
          errors: {},
          show:false,
          pass1:false,
          pass2:false,
          disabled: false
        }
    }    

    componentDidMount(){
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  
    handleValidation() {
     
      let fields = this.state.fields;
      let errors = {};
      let formIsValid = true;
      const f1 = fields["new_password"]
      const f2 = fields["confirm_password"]
      const passwordLength = /^(?=.*[\d]{1,})(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[~!@#$%^*)(}{><.,?})]).{8,16}$/;
      const forbiddenChara = ['[', ']', `"`, "'", "`", '\\', '-', '_', ';', ':', '=']

      if (f1==="" || f2==="" || (f1 != f2) || (!f1.match(passwordLength) || !f2.match(passwordLength)) ){
        formIsValid = false;
      } else {
        formIsValid = true;
      }



      if(!fields["new_password"]) {
        errors["new_password"] = "New password tidak boleh kosong";
      } else {
        let tmp = fields["new_password"].split('')
        let num = 0

        for (let i = 0; i < forbiddenChara.length; i++) {
          if (tmp.includes(forbiddenChara[i])) {
            num++
          }
        }

        if (num > 0) {
          errors["new_password"] = "Password contains forbidden characters"
        } else {
          if (!fields["new_password"].match(passwordLength)) {
            errors["new_password"] = "Password must be at least 8 characters contains a capital letter, a symbol, and a number";
          }
        }
      }

      if(!fields["confirm_password"]) {
        errors["confirm_password"] = "Password confirmation cannot be empty";
      } else {
          let tmp = fields["confirm_password"].split('')
          let num = 0
  
          for (let i = 0; i < forbiddenChara.length; i++) {
            if (tmp.includes(forbiddenChara[i])) {
              num++
            }
          }
  
          if (num > 0) {
            errors["new_password"] = "Password contains forbidden characters"
          } else {
            if (!fields["new_password"].match(passwordLength)) {
              errors["new_password"] = "Password must be at least 8 characters contains a capital letter, a symbol, and a number";
            }
          }
      }
      

      if((fields["new_password"]) !== (fields["confirm_password"])) {
        errors["confirm_password"] = "Confirm Password and New Password is different";
      }

     
      // if(!fields["new_password"].match(passwordLength) || !fields["confirm_password"].match(passwordLength)) {
      //   errors["new_password"] = "Password min. 8 characters and contain uppercase, lowercase letters, numbers and symbols";
      // }

      this.setState({errors: errors, formIsValid:formIsValid});
        // return formIsValid;
    }

    changePassword = (e) => {
      e.preventDefault();
 
      let fields = this.state.fields;
      let errors = {};
      let val 
      const f1 = fields["new_password"]
      const f2 = fields["confirm_password"]
        
      const forbiddenChara = ['[', ']', `"`, "'", "`", '\\', '-', '_', ';', ':', '=']
      const passwordLength = /^(?=.*[\d]{1,})(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[~!@#$/€£¥%&^|+=*)(}{><.,?})]).{8,16}$/;
      if (f1==="" || f2==="" || (f1 != f2) || (!f1.match(passwordLength) || !f2.match(passwordLength)) ){
        val = false;
        if(!fields["new_password"]){
          errors["new_password"] = "New Password cannot be empty";
        } else {
          let tmp = fields["new_password"].split('')
          let num = 0;

          for (let i = 0; i < forbiddenChara.length; i++) {
            if (tmp.includes(forbiddenChara[i])) {
              num++
            }
          }

          if (num > 0) {
            errors["new_password"] = "Password contains forbidden character";
          } else {
            if(!fields["new_password"].match(passwordLength) ){
              errors["new_password"] = "Password must be at least 8 characters contains a capital letter, a symbol, and a number";
            }
          }
        }
  
        if(!fields["confirm_password"]){
          errors["confirm_password"] = "New Password Confirmation cannot be empty";
        } else {
          let tmp = fields["confirm_password"].split('')
          let num = 0;

          for (let i = 0; i < forbiddenChara.length; i++) {
            if (tmp.includes(forbiddenChara[i])) {
              num++
            }
          }

          if (num > 0) {
            errors["confirm_password"] = "Password contains forbidden characters";
          } else {
            if(!fields["confirm_password"].match(passwordLength) ){
              errors["confirm_password"] = "Password must be at least 8 characters contains a capital letter, a symbol, and a number";
            }
          }
        }
  
        if((fields["new_password"]) !== (fields["confirm_password"])) {
          errors["confirm_password"] = "Confirm Password and New Password is different";
        } 
        // else{
        //   errors["confirm_password"] = ""
        // }

      }else{
        val = true;

          let data = {
          new_password: this.state.fields["new_password"],
          confirm_password: this.state.fields["confirm_password"]
        };
        data["new_password"] = CryptoJS.TripleDES.encrypt(data["new_password"], key, { iv: iv, mode: CryptoJS.mode.CBC }).toString()
        data["confirm_password"] = CryptoJS.TripleDES.encrypt(data["confirm_password"], key, { iv: iv, mode: CryptoJS.mode.CBC }).toString()
        
        const search = window.location.search
        const params = new URLSearchParams(search)
        const token1 = params.get('token')
        var jwt = require("jsonwebtoken");
        var decode1 = jwt.decode(token1);
        var user_id = decode1["user_id"];
        putPasswordEmail(user_id, data, token1)
      }
      this.setState({errors: errors});

      GAevent(`Submit Change Password - ${window.location.pathname}`,'Submit Change Password'); 
      ReactPixel.track(`Submit Change Password - ${window.location.pathname}`,'Submit Change Password'); 
    };
    
  
    handleChange(field, e) {
      let fields = this.state.fields;
      fields[field] = e.target.value;
      this.setState({ fields });
    }

    showPassword=(e)=>{
      if (e===1){
        this.setState({pass1:!this.state.pass1})
      }else{
        this.setState({pass2:!this.state.pass2})
      }
    }

    render() {
      const {show, pass1, pass2}= this.state

        return (
          <div className='Ch-pass'>
            <div className="changepwd-title">
              {/* <LazyLoadImage effect="blur" loading="lazy" alt="" src={karya} /> */}
              <h1 className="title-changepwd" >Change Password</h1>
            </div>
            <div className="box-changepwd" >
              <form id="changePassword">
                <div className="box-changepwd-container">
                  <div className={"box-changepwd-input show-pass"}>
                    <p className="text-change-item" >Password</p>
                    <TextField label="New Password" variant="outlined" type={pass1?"text":"password"} className="form-control" placeholder="New Password"
                      name="new_password" id="new_password" refs="new_password" aria-describedby="emailHelp" onChange={this.handleChange.bind(this, "new_password")}
                      value={this.state.fields["new_password"]} />
                       {pass1===false &&
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>this.showPassword(1)}>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29077 8.2301C6.1648 6.67673 8.89044 5 12 5C15.1096 5 17.8352 6.67673 19.7092 8.2301C20.6604 9.01854 21.4277 9.8047 21.9576 10.3937C22.2231 10.6888 22.4305 10.9362 22.5732 11.1119C22.6445 11.1997 22.6998 11.2698 22.7381 11.3191C22.7572 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7572 12.6562 22.7381 12.6809C22.6998 12.7302 22.6445 12.8003 22.5732 12.8881C22.4305 13.0638 22.2231 13.3112 21.9576 13.6063C21.4277 14.1953 20.6604 14.9815 19.7092 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89044 19 6.1648 17.3233 4.29077 15.7699C3.33956 14.9815 2.57228 14.1953 2.04241 13.6063C1.77689 13.3112 1.56947 13.0638 1.42684 12.8881C1.35548 12.8003 1.30024 12.7302 1.26193 12.6809C1.24277 12.6562 1.22785 12.6367 1.21725 12.6228L1.20461 12.6061L1.20075 12.601L1.19944 12.5992C1.19923 12.599 1.19854 12.598 2 12C1.19854 11.402 1.19873 11.4017 1.19893 11.4014L1.20075 11.399L1.20461 11.3939L1.21725 11.3772C1.22785 11.3633 1.24277 11.3438 1.26193 11.3191C1.30024 11.2698 1.35548 11.1997 1.42684 11.1119C1.56947 10.9362 1.77689 10.6888 2.04241 10.3937C2.57228 9.8047 3.33956 9.01854 4.29077 8.2301ZM2 12L1.19893 11.4014C0.934218 11.7562 0.933821 12.2433 1.19854 12.598L2 12ZM3.29219 12C3.36395 12.083 3.44309 12.1729 3.52929 12.2687C4.01148 12.8047 4.70865 13.5185 5.5671 14.2301C7.31235 15.6767 9.58671 17 12 17C14.4133 17 16.6877 15.6767 18.4329 14.2301C19.2913 13.5185 19.9885 12.8047 20.4707 12.2687C20.5569 12.1729 20.636 12.083 20.7078 12C20.636 11.917 20.5569 11.8271 20.4707 11.7313C19.9885 11.1953 19.2913 10.4815 18.4329 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58671 7 7.31235 8.32327 5.5671 9.7699C4.70865 10.4815 4.01148 11.1953 3.52929 11.7313C3.44309 11.8271 3.36395 11.917 3.29219 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z" fill="#292929"/>
                        </svg>}
                        {pass1===true &&
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>this.showPassword(1)}>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29077 8.2301C6.1648 6.67673 8.89044 5 12 5C15.1096 5 17.8352 6.67673 19.7092 8.2301C20.6604 9.01854 21.4277 9.8047 21.9576 10.3937C22.2231 10.6888 22.4305 10.9362 22.5732 11.1119C22.6445 11.1997 22.6998 11.2698 22.7381 11.3191C22.7572 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7572 12.6562 22.7381 12.6809C22.6998 12.7302 22.6445 12.8003 22.5732 12.8881C22.4305 13.0638 22.2231 13.3112 21.9576 13.6063C21.4277 14.1953 20.6604 14.9815 19.7092 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89044 19 6.1648 17.3233 4.29077 15.7699C3.33956 14.9815 2.57228 14.1953 2.04241 13.6063C1.77689 13.3112 1.56947 13.0638 1.42684 12.8881C1.35548 12.8003 1.30024 12.7302 1.26193 12.6809C1.24277 12.6562 1.22785 12.6367 1.21725 12.6228L1.20461 12.6061L1.20075 12.601L1.19944 12.5992C1.19923 12.599 1.19854 12.598 2 12C1.19854 11.402 1.19873 11.4017 1.19893 11.4014L1.20075 11.399L1.20461 11.3939L1.21725 11.3772C1.22785 11.3633 1.24277 11.3438 1.26193 11.3191C1.30024 11.2698 1.35548 11.1997 1.42684 11.1119C1.56947 10.9362 1.77689 10.6888 2.04241 10.3937C2.57228 9.8047 3.33956 9.01854 4.29077 8.2301ZM2 12L1.19893 11.4014C0.934218 11.7562 0.933821 12.2433 1.19854 12.598L2 12ZM3.29219 12C3.36395 12.083 3.44309 12.1729 3.52929 12.2687C4.01148 12.8047 4.70865 13.5185 5.5671 14.2301C7.31235 15.6767 9.58671 17 12 17C14.4133 17 16.6877 15.6767 18.4329 14.2301C19.2913 13.5185 19.9885 12.8047 20.4707 12.2687C20.5569 12.1729 20.636 12.083 20.7078 12C20.636 11.917 20.5569 11.8271 20.4707 11.7313C19.9885 11.1953 19.2913 10.4815 18.4329 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58671 7 7.31235 8.32327 5.5671 9.7699C4.70865 10.4815 4.01148 11.1953 3.52929 11.7313C3.44309 11.8271 3.36395 11.917 3.29219 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z" fill="#292929"/>
                          <line x1="19.7231" y1="4.29703" x2="3.96037" y2="20.0598" stroke="#292929" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        }
                    <div style={{ color: "red", fontSize: "12px", margin: "0% 5% 1%" }}>{this.state.errors["new_password"]}</div>
                  </div>
                  <div className={"box-changepwd-input show-pass"}>
                    <p className="text-change" style={{marginTop:"30px"}} >New Password Confirmation</p>
                    <TextField label="New Password Confirmation" variant="outlined" type={pass2?"text":"password"} className="form-control" placeholder="New Password Confirmation"
                      name="confirm_password" id="confirm_password" refs="confirm_password" aria-describedby="emailHelp" onChange={this.handleChange.bind(this, "confirm_password")}
                      value={this.state.fields["confirm_password"]} />
                       {pass2===false &&
                         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>this.showPassword(2)}>
                         <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29077 8.2301C6.1648 6.67673 8.89044 5 12 5C15.1096 5 17.8352 6.67673 19.7092 8.2301C20.6604 9.01854 21.4277 9.8047 21.9576 10.3937C22.2231 10.6888 22.4305 10.9362 22.5732 11.1119C22.6445 11.1997 22.6998 11.2698 22.7381 11.3191C22.7572 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7572 12.6562 22.7381 12.6809C22.6998 12.7302 22.6445 12.8003 22.5732 12.8881C22.4305 13.0638 22.2231 13.3112 21.9576 13.6063C21.4277 14.1953 20.6604 14.9815 19.7092 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89044 19 6.1648 17.3233 4.29077 15.7699C3.33956 14.9815 2.57228 14.1953 2.04241 13.6063C1.77689 13.3112 1.56947 13.0638 1.42684 12.8881C1.35548 12.8003 1.30024 12.7302 1.26193 12.6809C1.24277 12.6562 1.22785 12.6367 1.21725 12.6228L1.20461 12.6061L1.20075 12.601L1.19944 12.5992C1.19923 12.599 1.19854 12.598 2 12C1.19854 11.402 1.19873 11.4017 1.19893 11.4014L1.20075 11.399L1.20461 11.3939L1.21725 11.3772C1.22785 11.3633 1.24277 11.3438 1.26193 11.3191C1.30024 11.2698 1.35548 11.1997 1.42684 11.1119C1.56947 10.9362 1.77689 10.6888 2.04241 10.3937C2.57228 9.8047 3.33956 9.01854 4.29077 8.2301ZM2 12L1.19893 11.4014C0.934218 11.7562 0.933821 12.2433 1.19854 12.598L2 12ZM3.29219 12C3.36395 12.083 3.44309 12.1729 3.52929 12.2687C4.01148 12.8047 4.70865 13.5185 5.5671 14.2301C7.31235 15.6767 9.58671 17 12 17C14.4133 17 16.6877 15.6767 18.4329 14.2301C19.2913 13.5185 19.9885 12.8047 20.4707 12.2687C20.5569 12.1729 20.636 12.083 20.7078 12C20.636 11.917 20.5569 11.8271 20.4707 11.7313C19.9885 11.1953 19.2913 10.4815 18.4329 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58671 7 7.31235 8.32327 5.5671 9.7699C4.70865 10.4815 4.01148 11.1953 3.52929 11.7313C3.44309 11.8271 3.36395 11.917 3.29219 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z" fill="#292929"/>
                         </svg>}
                          {pass2===true &&
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>this.showPassword(2)}>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29077 8.2301C6.1648 6.67673 8.89044 5 12 5C15.1096 5 17.8352 6.67673 19.7092 8.2301C20.6604 9.01854 21.4277 9.8047 21.9576 10.3937C22.2231 10.6888 22.4305 10.9362 22.5732 11.1119C22.6445 11.1997 22.6998 11.2698 22.7381 11.3191C22.7572 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7572 12.6562 22.7381 12.6809C22.6998 12.7302 22.6445 12.8003 22.5732 12.8881C22.4305 13.0638 22.2231 13.3112 21.9576 13.6063C21.4277 14.1953 20.6604 14.9815 19.7092 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89044 19 6.1648 17.3233 4.29077 15.7699C3.33956 14.9815 2.57228 14.1953 2.04241 13.6063C1.77689 13.3112 1.56947 13.0638 1.42684 12.8881C1.35548 12.8003 1.30024 12.7302 1.26193 12.6809C1.24277 12.6562 1.22785 12.6367 1.21725 12.6228L1.20461 12.6061L1.20075 12.601L1.19944 12.5992C1.19923 12.599 1.19854 12.598 2 12C1.19854 11.402 1.19873 11.4017 1.19893 11.4014L1.20075 11.399L1.20461 11.3939L1.21725 11.3772C1.22785 11.3633 1.24277 11.3438 1.26193 11.3191C1.30024 11.2698 1.35548 11.1997 1.42684 11.1119C1.56947 10.9362 1.77689 10.6888 2.04241 10.3937C2.57228 9.8047 3.33956 9.01854 4.29077 8.2301ZM2 12L1.19893 11.4014C0.934218 11.7562 0.933821 12.2433 1.19854 12.598L2 12ZM3.29219 12C3.36395 12.083 3.44309 12.1729 3.52929 12.2687C4.01148 12.8047 4.70865 13.5185 5.5671 14.2301C7.31235 15.6767 9.58671 17 12 17C14.4133 17 16.6877 15.6767 18.4329 14.2301C19.2913 13.5185 19.9885 12.8047 20.4707 12.2687C20.5569 12.1729 20.636 12.083 20.7078 12C20.636 11.917 20.5569 11.8271 20.4707 11.7313C19.9885 11.1953 19.2913 10.4815 18.4329 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58671 7 7.31235 8.32327 5.5671 9.7699C4.70865 10.4815 4.01148 11.1953 3.52929 11.7313C3.44309 11.8271 3.36395 11.917 3.29219 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z" fill="#292929"/>
                            <line x1="19.7231" y1="4.29703" x2="3.96037" y2="20.0598" stroke="#292929" stroke-width="2" stroke-linecap="round"/>
                          </svg>
                          }
                    <div style={{ color: "red", fontSize: "12px", margin: "0% 5% 1%" }}>{this.state.errors["confirm_password"]}</div>
                  </div>
                  <div style={{marginLeft:"5%"}} >
                    <Button id="button" type="submit" variant="outlined" onClick={this.changePassword}
                      style={{ marginTop: "9px", backgroundColor: "#3B6C98", color: "white" }}>
                      Change Password
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    data: state.passwordEmail,
    user_id: state.user_id
  };
};

const mapDispatchToProps = dispatch => {
  return {
    password1: (user_id) => {
      dispatch(putPasswordEmail(user_id));
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(ChangePwd);